const STATUS = {
  new: { tone: "muted", label: "New" },
  scheduled: { tone: "info", label: "Scheduled" },
  in_progress: { tone: "warning", label: "In Progress" },
  completed: { tone: "indigo", label: "Completed" },
  closed: { tone: "success", label: "Closed" },
  aborted: { tone: "destructive", label: "Aborted" },
};

// Tailwind class table for the 5 tones — inlined to match design system exactly.
const TONE = {
  muted: "bg-muted text-muted-foreground border-border",
  info: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  warning: "bg-amber-500/10 text-amber-700 border-amber-500/20",
  indigo: "bg-indigo-500/10 text-indigo-600 border-indigo-500/20",
  success: "bg-green-500/10 text-green-700 border-green-500/20",
};

export default function JobStatusBadge({ status, testId }) {
  const s = STATUS[status] || { tone: "muted", label: status };
  return (
    <span
      data-testid={testId || `job-status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${TONE[s.tone]}`}
    >
      {s.label}
    </span>
  );
}

const PRIORITY_TONE = {
  low: "bg-muted text-muted-foreground border-border",
  normal: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  high: "bg-red-500/10 text-red-600 border-red-500/20",
};

export function JobPriorityBadge({ priority, testId }) {
  const cls = PRIORITY_TONE[priority] || PRIORITY_TONE.normal;
  const label = { low: "Low", normal: "Normal", high: "High" }[priority] || priority;
  return (
    <span
      data-testid={testId || `job-priority-${priority}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${cls}`}
    >
      {label}
    </span>
  );
}
